/**
 * How a script scrolls the booking pages: smoothly, unless the patient asked for less motion. A
 * script's "smooth" overrides the stylesheet's reduced-motion rule, so it must ask here.
 */
export function scrollBehavior(): ScrollBehavior {
  const reduceMotion =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  return reduceMotion ? "auto" : "smooth";
}
